import Image from "next/image";
import DeclarationBoxData from "../variables/variables.json";
import { useRouter } from "next/router";
import TranslatedMessage from "./TranslatedMessage";
import classNames from "classname";
import Link from "next/link";

const DeclarationBoxItem = (props) => {
	const router = useRouter();

	// PROPS VARIABLE
	let propsMiasto = props.miasto;
	let propsPodatek = props.podatek;

	let propsType;
	let extendedUrl = "";
	let siteCode = router.query.siteCode;

	// JSON VARIABLE
	let miastoJSON = DeclarationBoxData.miasta[propsMiasto];

	let resources = "https://przyjazne-deklaracje.pl/resources/images/icons/general/";

	let declarationLists = DeclarationBoxData.declarationBox.lists[propsPodatek];

	let declarationImageUrl =
		resources + declarationLists.image.url + "/" + declarationLists.image.url;

	let declarationModalAvailable = declarationLists.modal.available;

	let declarationModalData = declarationLists.modal.data;

	let declarationReadMore = declarationLists.readmore;
	let declarationReadMoreAvailable = declarationReadMore.available;
	let declarationReadMoreUrl = declarationReadMore.url;

	let miastoUrl = DeclarationBoxData.miasta[propsMiasto].name.url;

	let startUrl;
	let startUrlProd = "https://przyjazne-deklaracje.pl/";
	let startUrlTest = "https://test.przyjazne-deklaracje.pl/";

	if (DeclarationBoxData.miasta[propsMiasto].test) {
		startUrl = startUrlTest;
	} else {
		startUrl = startUrlProd;
	}

	let profileCode = "O4B";
	let templateCode = declarationLists.templateCode;
	let templateScope = DeclarationBoxData.miasta[propsMiasto].templateScope;
	let templateScopeFull = "&templateScope=" + templateScope;

	if (DeclarationBoxData.miasta[propsMiasto].index) {
		propsType = "/";
		templateScopeFull = "";
	} else if (DeclarationBoxData.miasta[propsMiasto].witryna) {
		propsType = "/witryna/";
		extendedUrl = "?siteCode=" + siteCode;
	} else {
		propsType = "/" + DeclarationBoxData.miasta[propsMiasto].name.url + "/";
	}

	let linkTo =
		startUrl +
		"kalkulatory/menadzer/menadzer-kalkulatorow?profileCode=" +
		profileCode +
		"&templateCode=" +
		templateCode +
		templateScopeFull;

	let ariaLabel = declarationLists.aria.label;

	const handleDialogKeyDown = (event) => {
		if (!declarationModalAvailable) {
			return;
		}

		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			event.currentTarget.click();
		}
	};

	return (
		<>
			<div className="declaration-box__col">
				<div
					className={classNames("declaration-box", {
						"declaration-box__soon": props.soon,
					})}
					data-a11y-dialog-show={declarationModalAvailable ? declarationModalData : undefined}
					role={declarationModalAvailable ? "button" : undefined}
					aria-haspopup={declarationModalAvailable ? "dialog" : undefined}
					aria-controls={declarationModalAvailable ? declarationModalData : undefined}
					tabIndex={declarationModalAvailable ? 0 : undefined}
					onKeyDown={handleDialogKeyDown}
					style={
						declarationModalAvailable
							? {
									touchAction: "manipulation",
								}
							: undefined
					}
				>
					{!props.soon && !declarationModalAvailable && (
						<Link
							className="declaration-box__full-link"
							href={linkTo}
							aria-label={ariaLabel}
							tabIndex="0"
						></Link>
					)}

					<div className="declaration-box__images">
						<div className="declaration-box__images__img--normal">
							<Image
								unoptimized
								src={declarationImageUrl + ".svg"}
								alt=""
								width={68}
								height={68}
								className="declaration-box__images__img"
								style={{
									maxWidth: "100%",
									height: "auto",
									pointerEvents: "none",
								}}
							/>
						</div>

						<div className="declaration-box__images__img--hover">
							<Image
								unoptimized
								src={declarationImageUrl + "-white.svg"}
								alt=""
								width={68}
								height={68}
								className="declaration-box__images__img"
								style={{
									maxWidth: "100%",
									height: "auto",
									pointerEvents: "none",
								}}
							/>
						</div>
					</div>

					<div className="declaration-box__action">
						<h3 className="declaration-box__heading">
							<TranslatedMessage id={"declarationBox.lists." + propsPodatek + ".title"} />
						</h3>

						<span className="declaration-box__action__text">
							<TranslatedMessage id="declarationBox.general.action" />
						</span>

						<span className="declaration-box__action__icon"></span>
					</div>
				</div>

				{props.noReadMore || !declarationReadMoreAvailable ? null : (
					<div className="declaration-box__read-more">
						<Link href={propsType + declarationReadMoreUrl + extendedUrl} aria-label={ariaLabel}>
							<TranslatedMessage id={"declarationBox.lists." + propsPodatek + ".readmore"} />
						</Link>
					</div>
				)}
			</div>
		</>
	);
};

export default DeclarationBoxItem;
